import { render, staticRenderFns } from "./View.vue?vue&type=template&id=4332deb9&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "./View.vue?vue&type=style&index=0&id=4332deb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332deb9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4332deb9')) {
      api.createRecord('4332deb9', component.options)
    } else {
      api.reload('4332deb9', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=4332deb9&scoped=true&", function () {
      api.rerender('4332deb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenders/View.vue"
export default component.exports